import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'root',
  'filterSectionWrapper',
  'filterSection',
  'filterChip',
  'filterChipText',
  'resultsCount',
  'contentSkeleton',
  'gridContainer',
  'emptyState',
  'loadMoreContainer',
  'container',
  'headerRow',
  'description',
  'twoColRow',
  'twoColLarge',
  'twoColSmall',
  'threeColRow',
  'ctaContainer',
]);

export const blogListingStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    root: {
      width: '100%',
      maxWidth: '1440px',
      mx: 'auto',
      px: {base: 5, md: 20},
      py: {base: 14, md: 20},
    },

    filterSectionWrapper: {
      display: 'flex',
      flexDirection: {base: 'column', md: 'row'},
      alignItems: {base: 'flex-start', md: 'center'},
      justifyContent: 'space-between',
      gap: {base: 4, md: 0},
      width: '100%',
      mb: {base: 6, md: 6},
    },

    filterSection: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 4,
      flexShrink: 0,
    },

    resultsCount: {
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '120%',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    },

    contentSkeleton: {
      width: '100%',
      minHeight: '400px',
    },

    filterChip: {
      display: 'flex',
      px: 4,
      py: 2,
      h: '35px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2.5,
      borderRadius: '50px',
      border: '1px solid',
      borderColor: 'brandColors.linen03',
      bg: 'transparent',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brandColors.primaryDarkLinen',
        outlineOffset: '2px',
      },
      sx: {
        '@media (hover: hover)': {
          '&:hover': {
            bg: 'brandColors.greyscale90',
            borderColor: 'brandColors.greyscale90',
          },
          '&:hover > p': {
            color: 'white',
          },
        },
        '&[data-active="true"]': {
          bg: 'brandColors.greyscale90 !important',
          borderColor: 'brandColors.greyscale90 !important',
        },
        '&[data-active="true"] > p': {
          color: 'white !important',
        },
      },
    },

    filterChipText: {
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
      whiteSpace: 'nowrap',
      sx: {
        '[data-active="true"] &': {
          color: 'white !important',
        },
      },
    },

    gridContainer: {
      width: '100%',
    },

    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: '400px',
      textAlign: 'center',
      py: {base: 12, md: 20},
      color: 'brandColors.greyscale70',
      fontSize: {base: '16px', md: '18px'},
      fontFamily: 'body',
      lineHeight: '150%',
    },

    loadMoreContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      pt: {base: 8, md: 12},
    },

    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 8, md: 10.5},
      width: '100%',
    },

    headerRow: {
      flexDirection: {base: 'column', md: 'row'},
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: {base: 4, md: 10},
      width: '100%',
      mb: {base: 2, md: 4},
    },

    description: {
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: '16px', md: '20px'},
      fontWeight: '400',
      lineHeight: {base: '160%', md: '150%'},
      margin: 0,
      flex: {base: 'none', md: '1'},
      maxWidth: {base: '100%', md: '55%'},
      mt: {base: 0, md: 10},
    },

    twoColRow: {
      display: 'flex',
      flexDirection: {base: 'column', md: 'row'},
      gap: {base: 15.25, md: 10.5},
      width: '100%',
      alignItems: 'stretch',
      sx: {
        '& + .blog-grid-listing__row--three-col': {
          py: {base: 0, md: 9.5},
        },
        '& .blog-summary__content h3': {
          fontSize: {base: '16px', md: '24px'},
        },
      },
    },

    twoColLarge: {
      flex: {base: '1 1 100%', md: '0 0 calc(65% - 21px)'},
      width: {base: '100%', md: 'auto'},
    },

    twoColSmall: {
      flex: {base: '1 1 100%', md: '0 0 calc(35% - 21px)'},
      width: {base: '100%', md: 'auto'},
    },

    threeColRow: {
      columns: {base: 1, md: 3},
      spacing: {base: 8, md: 10},
      width: '100%',
    },

    ctaContainer: {
      display: 'flex',
      justifyContent: {base: 'center', lg: 'center'},
      width: '100%',
      pt: {base: 4, md: 8},
    },
  },
});
